"use client";

import { useServerErrorMessage } from "@/lib/i18n/use-server-error-message";
import { api } from "@v1/backend/convex/_generated/api";
import type { Id } from "@v1/backend/convex/_generated/dataModel";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@v1/ui/dropdown-menu";
import { useMutation } from "convex/react";
import { MoreHorizontal, Users } from "lucide-react";
import { useTranslations } from "next-intl";
import type { ReactElement } from "react";
import { toast } from "sonner";
import { useMessengerSurface } from "./messenger-context";
import { MESSENGER_ICON_BUTTON_CLASS } from "./messenger-header";

/** `⋯` of a chat before it is a ticket: hand it to the team yourself. */
export function MessengerChatMenu({
  sessionId,
}: {
  readonly sessionId: Id<"public_chat_sessions">;
}): ReactElement {
  const t = useTranslations("messenger");
  const errorMessage = useServerErrorMessage();
  const surface = useMessengerSurface();
  const handToTeam = useMutation(api.customerChat.messenger_writes.handChatToTeam);
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label={t("header.mehr")} className={MESSENGER_ICON_BUTTON_CLASS}>
          <MoreHorizontal className="h-[18px] w-[18px]" strokeWidth={2} aria-hidden />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[1100] min-w-[200px]">
        <DropdownMenuItem
          className="cursor-pointer gap-2 text-left text-[13px]"
          onSelect={() => {
            void handToTeam({ surface, session_id: sessionId }).catch((error: unknown) =>
              toast.error(errorMessage(error, t("thread.fehler"))),
            );
          }}
        >
          <Users className="h-4 w-4 text-primary/55" strokeWidth={1.75} aria-hidden />
          {t("header.anTeamGeben")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
